/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Badges1Inputs */

const vi_sitesettings_brand_badges1 = /** @type {(inputs: Sitesettings_Brand_Badges1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huy hiệu (mục 1 = OCOP chính ở header, chân trang, Mini App)`)
};

/**

* @param {Sitesettings_Brand_Badges1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_badges1 = /** @type {((inputs?: Sitesettings_Brand_Badges1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Badges1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_badges1(inputs)
});
export { sitesettings_brand_badges1 as "siteSettings_brand_badges" }